export const  SCHEDULING_PROJECT_TEMPLATE_SOFT_CONSTRAINTS_MAP = [
  {
    key: 'maxVehicleGroupRouteDurationConstraint',
    switch: 'considerWeeklyHoursGoal',
    description: 'Target Weekly Hours For Balancing Utilization'
  },
  {
    key: 'maxRouteDurationConstraint',
    switch: 'considerDailyHoursGoal',
    description: 'Target Daily Hours For Balancing Utilization'
  },
  {
    key: 'locationVehiclePriorityUserdataConstraint',
    switch: 'considerPreferredAgents',
    description: 'Preference To Assign Accounts To Their Preferred Agents'
  },
  {
    key: 'minimizeLocationVisitsConstraint',
    switch: 'minimizeAccountVisits',
    description: 'Reduces Unnecessary Store Visits'
  },
  {
    key: 'branchRouteConstraint',
    switch: 'respectAssignedBranchesSoft',
    description: 'Ensures Routes Respect Assigned Territories'
  },
  {
    key: 'vehicleRoleSoftActivityConstraint',
    switch: 'rolesPriority',
    description: 'Apply Role/Tag-based Assignment Priority'
  }
];

export const visitPlanAccountsImportSampleFileLink = 'https://firebasestorage.googleapis.com/v0/b/bringoz-prod-imgs/o/import-xls-temp%2FVisit Plan Upload Accounts.xlsx?alt=media&token=792677c9-e61b-441c-9175-04865a1ce867';
export const visitPlanAccountsImportSampleFileName = 'visit-plan-upload-accounts-example.xlsx';
export const visitScheduleAgentsImportSampleFileLink = 'https://firebasestorage.googleapis.com/v0/b/bringoz-prod-imgs/o/import-xls-temp%2FVisit Schedule Upload Agents.xlsx?alt=media&token=cb7d5a2b-18de-4c44-984f-06d3f426d233';
export const visitScheduleAgentsImportSampleFileName = 'visit-schedule-upload-agents-example.xlsx';

export enum VisitPlanAuditLogFilters {
  ALL = 'ALL',
  CREATE_VISIT_PLAN = 'CREATE_VISIT_PLAN',
  UPDATE_VISIT_PLAN = 'UPDATE_VISIT_PLAN',
  ARCHIVE = 'ARCHIVE',
  RESTORE = 'RESTORE',
  PUBLISH = 'PUBLISH',
  ABORT_PUBLISH = 'ABORT_PUBLISH',
  RECALCULATE = 'RECALCULATE',
  INIT_VISIT_SCHEDULE = 'INIT_VISIT_SCHEDULE',
  OPTIMIZE = 'OPTIMIZE',
  ABORT_OPTIMIZATION = 'ABORT_OPTIMIZATION',
  UPDATE_VISIT_SCHEDULE = 'UPDATE_VISIT_SCHEDULE',
  VISIT_SCHEDULE_SYNC = 'VISIT_SCHEDULE_SYNC',
  IMPORT_AGENTS = 'IMPORT_AGENTS',
  CREATE_AVAILABILITY = 'CREATE_AVAILABILITY',
  AUTO_DISPATCH = 'AUTO_DISPATCH',
  OPTIMIZE_ROUTE = 'OPTIMIZE_ROUTE',
  PREPARE_DISPATCH = 'PREPARE_DISPATCH',
  UPDATE_DELIVERY_DATA = 'UPDATE_DELIVERY_DATA',
  CELL_UPDATED = 'CELL_UPDATED',
  DELETE_VISIT_SLOT_DELIVERIES = 'DELETE_VISIT_SLOT_DELIVERIES',
  DELETE_VISIT_SLOT_CALLS = 'DELETE_VISIT_SLOT_CALLS',
  DELETE_DELIVERY_DETAILS_CHANGES = 'DELETE_DELIVERY_DETAILS_CHANGES'
}

export const VISIT_PLAN_AUDIT_LOG_FILTERS = Object.values(VisitPlanAuditLogFilters);
